
import { BButton, BIconArrowClockwise } from 'bootstrap-vue';
import { defineComponent, PropType } from 'vue';

export default defineComponent({
  //Take the refreshFunction from the parent
  // so it can track the state of the update
  // and navbar toggle buttons
  props: {
    onRefresh: {
      type: Function as PropType<() => void>,
      required: true,
    },
  },
  components: {
    BButton,
    BIconArrowClockwise,
  },
  methods: {
    onRefreshClicked() {
      this.onRefresh();
    },
  },
});
